var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: this.$props.width,
        height: this.$props.height,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M20.8334 3.33325C30.4984 3.33325 38.3334 11.1683 38.3334 20.8333C38.3334 30.4982 30.4984 38.3333 20.8334 38.3333C11.1684 38.3333 3.33337 30.4982 3.33337 20.8333C3.33337 11.1683 11.1684 3.33325 20.8334 3.33325ZM20.8334 5.00024C12.0889 5.00024 5.00037 12.0887 5.00037 20.8333C5.00037 29.5778 12.0889 36.6663 20.8334 36.6663C29.5779 36.6663 36.6664 29.5778 36.6664 20.8333C36.6664 12.0887 29.5779 5.00024 20.8334 5.00024ZM21.6664 26.6663H20.0004V25.0002H21.6664V26.6663ZM20.8334 13.3333C21.2935 13.3333 21.6662 13.7062 21.6664 14.1663V20.8333C21.6664 21.2935 21.2936 21.6663 20.8334 21.6663C20.3731 21.6663 20.0004 21.2935 20.0004 20.8333V14.1663C20.0005 13.7062 20.3732 13.3333 20.8334 13.3333Z",
          fill: this.$props.fill,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }